import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Input, Row, Table, Tabs, message } from 'antd'
import SearchOutlined from '@ant-design/icons/lib/icons/SearchOutlined'
import personalizacionTicketSrc from './personalizacionTicketSrc'
import LoadMoreButton from '../../../../../components/LoadMoreButton'
import Utils from '../../../../../utils/Utils'
import PersonalizacionTicketDrawer from './personalizacionTicketDrawer'
import { PersonalizacionTicketCompany } from './personalizacionTicketCompanyIndex'

const { Search } = Input
const { TabPane } = Tabs

const PersonalizacionTicketStoreWidth = () => {
  const [loading, setLoading] = useState(false)
  const [visible, setVisible] = useState(false)
  const [dataSource, setDataSource] = useState([])
  const [nextPage, setNextPage] = useState('')
  const [existMoreInfo, setExistMoreInfo] = useState(false)
  const [editDataDrawer, setEditDataDrawer] = useState(null)

  useEffect(() => {
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const loadData = () => {
    setLoading(true)
    setVisible(false)
    personalizacionTicketSrc
      .readStores('', 5, true, 'desc')
      .then(result => {
        setDataSource(getStores(result))
        setNextPage(result.data.next_page_url)
        setExistMoreInfo(result.data.next_page_url !== null)
        setLoading(false)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información')
      })
  }

  const getStores = dataSrc => {
    if (dataSrc !== 'Too Many Attempts.') {
      let _dataSrc = dataSrc.data.data || []
      return _dataSrc.map((d, i) => ({
        key: i,
        id: d.id,
        name: d.name,
        company_name: d.company?.name,
        ticket_print_width: d.ticket_print_width || '3',
        ticket_logo: d.company?.ticket_logo,
        ticket_legend: d.company?.ticket_legend,
        subject_quarterly_isr: d.company?.subject_quarterly_isr,
        iva_retention_agent: d.company?.iva_retention_agent,
      }))
    } else {
      message.error('Se excedió el límite de peticiones, espera y recarga la aplicación')
    }
  }

  const moreInfo = () => {
    if (existMoreInfo) {
      setLoading(true)
      Utils.getNextPage(nextPage)
        .then(response => {
          setDataSource(dataSource.concat(getStores(response)))
          setNextPage(response.data.next_page_url)
          setExistMoreInfo(response.data.next_page_url !== null)
          setLoading(false)
        })
        .catch(err => {
          console.log(err)
          message.error('No se ha podido cargar la información')
        })
    }
  }

  const searchText = value => {
    setLoading(true)
    const excludeChars = Utils.excludedCharsContent(value)
    personalizacionTicketSrc
      .readStores(value, 5, excludeChars, 'desc')
      .then(result => {
        setDataSource(getStores(result))
        setNextPage(result.data.next_page_url)
        setExistMoreInfo(result.data.next_page_url !== null)
        setLoading(false)
      })
  }

  const EditRow = data => {
    setVisible(true)
    setEditDataDrawer(data)
  }

  const onClose = () => {
    setVisible(false)
  }

  const onSaveButton = (storeId, data) => {
    personalizacionTicketSrc
      .updateStoreTicketPersonalization(storeId, data)
      .then(res => {
        if (res.errors && Object.keys(res.errors)?.length > 0) {
          Utils.checkErrors(res)
        } else {
          message.success('Información actualizada.')
          loadData()
        }
      })
      .catch(e => {
        console.log(e)
        message.error('Error al actualizar la información.')
      })
  }

  const columns = [
    {
      title: 'Tienda',
      dataIndex: 'name',
      key: 'name',
      render: text => <span>{text}</span>,
    },
    {
      title: 'Empresa',
      dataIndex: 'company_name',
      key: 'company_name',
      render: text => <span>{text}</span>,
    },
    {
      title: 'Ancho de impresión',
      dataIndex: 'ticket_print_width',
      key: 'ticket_print_width',
      render: width => <span>{`${width}"`}</span>,
    },
    {
      title: '',
      dataIndex: 'id',
      key: 'actions',
      align: 'right',
      render: (id, row) => (
        <Button type="link" onClick={() => EditRow(row)}>
          Editar
        </Button>
      ),
    },
  ]

  return (
    <>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Search
            className={'customSearch'}
            prefix={<SearchOutlined className={'tendero-table-search-icon'} />}
            placeholder="Presiona enter para buscar"
            style={{ width: '40%', height: '40px' }}
            size={'large'}
            onSearch={searchText}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card className={'card-border-radius margin-top-15'}>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Table loading={loading} className={'CustomTableClass'} dataSource={dataSource} columns={columns} pagination={false} rowKey="id" />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <LoadMoreButton handlerButton={moreInfo} moreInfo={existMoreInfo} />
      <PersonalizacionTicketDrawer closable={onClose} visible={visible} editData={editDataDrawer} cancelButton={onClose} saveButton={onSaveButton} />
    </>
  )
}

export const PersonalizacionTicket = () => (
  <Tabs id={'personalizacionTicketTabs'} defaultActiveKey="1">
    <TabPane tab="Logo y leyenda (por empresa)" key="1">
      <PersonalizacionTicketCompany />
    </TabPane>
    <TabPane tab="Ancho de impresión (por tienda)" key="2">
      <PersonalizacionTicketStoreWidth />
    </TabPane>
  </Tabs>
)
